import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Services } from '../services/servicos';
import { LoginModel } from './login-model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public usuario:LoginModel = new LoginModel();
    loading = false;
    submitted = false;
    returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: Services) { }

  ngOnInit() {
     // reset login status
     this.authService.logout();

     // obtenha o URL de retorno dos parâmetros da rota ou o padrão como "/"
     this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login(){

    try 
    { 
        this.loading = true;
        this.authService.Login(this.usuario).subscribe(data => {

        if(data.Success){
          localStorage.setItem('currentUser', JSON.stringify(data.Response));
          //this.router.navigate(['/principal']);                    
          this.router.navigate([this.returnUrl]);
        }
        else
        {
          alert(data.Message);
          this.loading = false;
        }
            
      },
      err => console.error(err)
      );
    }
      catch(err) {
        alert(err.message);
        this.loading = false;
      }
   }  
}
